module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamics"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-product"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品：")]), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.productList), function(item) {
    return _c('div', {
      key: item._id,
      staticClass: "list-item",
      class: {
        'active': _vm.searchParams.productionId === item._id
      },
      on: {
        "click": function($event) {
          _vm.handleProductClick(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }))]), _c('div', {
    staticClass: "search-date"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("日期：")]), _c('div', {
    staticClass: "list search-input"
  }, [_c('el-date-picker', {
    staticClass: "search_range",
    attrs: {
      "type": "daterange",
      "range-separator": "-",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "placeholder": "选择日期范围"
    },
    on: {
      "change": _vm.handleDateChange
    },
    model: {
      value: (_vm.timer),
      callback: function($$v) {
        _vm.timer = $$v
      },
      expression: "timer"
    }
  })], 1)])]), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    ref: "multipleTable",
    staticClass: "v2table",
    attrs: {
      "data": _vm.dynamicList,
      "tooltip-effect": "dark",
      "border": "",
      "width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "80",
      "label": "序号"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "production",
      "width": "150",
      "label": "产品"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "htmlText",
      "label": "更新摘要"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "width": "100",
      "label": "版本"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "displayTime",
      "width": "120",
      "label": "更新日期"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "详情",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-blue",
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleDetail(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1), _c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pageNum,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "sizes, total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2540d5a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductDynamics/Index.vue
// module id = 402
// module chunks = 0